import React, {Suspense} from 'react';
import {Spin} from 'antd';

// Lazy-load Monaco only when the Technical tab is actually opened. The
// editor alone is ~3 MB of JS; pulling it on the landing page would waste
// bandwidth for users who never touch the raw YAML. React.lazy dedup-caches
// the dynamic import, so the two named exports share one chunk.
const LazyTechnicalEditor = React.lazy(() =>
    import('./technical-editor-impl').then((m) => ({default: m.TechnicalEditor})),
);
const LazyJavascriptTechnicalEditor = React.lazy(() =>
    import('./technical-editor-impl').then((m) => ({default: m.JavascriptTechnicalEditor})),
);

const EditorFallback = () => (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: 400}}>
        <Spin tip="Loading editor..." />
    </div>
);

export function TechnicalEditor(props) {
    return (
        <Suspense fallback={<EditorFallback />}>
            <LazyTechnicalEditor {...props} />
        </Suspense>
    );
}

export function JavascriptTechnicalEditor(props) {
    return (
        <Suspense fallback={<EditorFallback />}>
            <LazyJavascriptTechnicalEditor {...props} />
        </Suspense>
    );
}
